import Categories from 'components/blog/categories'
import D from 'date-fns'
import Image from 'next/legacy/image'
import Link from 'next/link'
import AuthorCardSection from '../author'
import FeatureFlatCard from './feature'
import s from './styles.module.css'

export default function FlatCard({ categories = [], post, isFeature = false }) {
  if (isFeature) {
    return <FeatureFlatCard categories={categories} post={post} />
  }

  return (
    <article className={s.flatCard}>
      <Link href={`/blog/${post.fields?.slug}`} className={s.postLink}>
        <div className={s.topRow}>
          <div className={s.imageWrapper}>
            {post.fields.featureImage && post.fields.featureImage.fields && (
              <Image
                alt={post.fields.featureImage.fields.title}
                src={`https:${post.fields.featureImage.fields.file.url}`}
                layout="fill"
                objectFit="cover"
              />
            )}
          </div>
          <div>
            <Categories categories={categories} className={s.categories} />
            <h2 className={s.title}>{post.fields.title}</h2>
            <div className={s.cardFooter}>
              <AuthorCardSection post={post} />
            </div>
          </div>
          <div className={s.mobileImageWrapper}>
            {post.fields.featureImage && post.fields.featureImage.fields && (
              <Image
                alt={post.fields.featureImage.fields.title}
                src={`https:${post.fields.featureImage.fields.file.url}`}
                layout="fill"
                objectFit="cover"
              />
            )}
          </div>
          <div className={s.mobileFooter}>
            <span className={s.name}>{post.fields.author?.fields.name}</span>
            <span className={s.dot}>&bull;</span>
            <span className={s.dateAndReadTime}>
              {D.format(post.fields.createdAt, 'MMM D, YYYY')}
            </span>
            <span className={s.dot}>&bull;</span>
            {/* <span className={s.dateAndReadTime}>5 min reed</span> */}
          </div>
        </div>
      </Link>
    </article>
  )
}
